module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-input-group has-checkbox"
  }, [_c('label', {
    staticClass: "p-checkbox",
    class: {
      'focus': _vm.focused, 'disabled': _vm.disabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.innerModel),
      expression: "innerModel"
    }],
    attrs: {
      "disabled": _vm.disabled,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.innerModel) ? _vm._i(_vm.innerModel, null) > -1 : (_vm.innerModel)
    },
    on: {
      "focus": function($event) {
        _vm.focused = true
      },
      "focusout": function($event) {
        _vm.focused = false
      },
      "change": _vm.onChange,
      "__c": function($event) {
        var $$a = _vm.innerModel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.innerModel = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.innerModel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.innerModel = $$c
        }
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.label) + "\n    "), _c('span', {
    staticClass: "p-check-lever"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43f1b32e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/checkbox.vue
// module id = 34
// module chunks = 0